module.exports = __webpack_public_path__ + "img/star.513203ea.svg";